var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('NYCXDiscountByItemCodeTable',{staticClass:"mt-3",attrs:{"selectedDateRange":_vm.selectedDateRange}}),_c('NYCXDiscountByTotalTable',{staticClass:"mt-3",attrs:{"selectedDateRange":_vm.selectedDateRange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }